const APPCUES_ACCOUNT_ID = 206911;

export class UnauthenticatedAppcuesService {
    initialize() {
        const script = document.createElement('script') as HTMLScriptElement;
        script.type = 'text/javascript';
        script.src = `//fast.appcues.com/${APPCUES_ACCOUNT_ID}.js`;
        script.async = true;
        script.onload = () => {
            window.AppcuesSettings = { enableURLDetection: true };
            if (!window.Appcues) {
                return;
            }

            if (typeof window.Appcues.anonymous === 'function') {
                window.Appcues.anonymous();
            }
        };
        document.head.appendChild(script);
    }
}
